import React, { useState } from 'react';
import { MapPin, Phone, Mail, Send } from 'lucide-react';
import { useToast } from '../hooks/use-toast';
import './Contact.css';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Simulate form submission
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      toast({
        title: "Message envoyé / Message sent!",
        description: "Nous vous contacterons bientôt / We will contact you soon!",
      });

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
    } catch (error) {
      toast({
        title: "Erreur / Error",
        description: "Une erreur s'est produite / An error occurred",
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <h2 className="section-title">Contactez-nous / Contact Us / Kontaktieren Sie Uns</h2>

        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-card">
              <MapPin size={32} className="contact-icon" />
              <h3>Adresse / Address / Adresse</h3>
              <p>Lerchenstr 5 Eingang II</p>
              <p>80995 München</p>
              <p>Deutschland / Germany / Allemagne</p>
            </div>
            <div className="contact-card">
              <Phone size={32} className="contact-icon" />
              <h3>Téléphone / Phone / Telefon</h3>
              <p><strong><a href="tel:017672569441">0176 72569441</a></strong></p>
            </div>
            <div className="contact-card">
              <Mail size={32} className="contact-icon" />
              <h3>Email / Courriel / E-Mail</h3>
              <p><strong><a href="mailto:gemeindempev@gmail.com">gemeindempev@gmail.com</a></strong></p>
            </div>
          </div>

          <div className="contact-form">
            <h3 className="form-title">
              Envoyez-nous un message<br />
              Send us a message<br />
              Senden Sie uns eine Nachricht
            </h3>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nom / Name / Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email / E-Mail *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Téléphone / Phone / Telefon</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message / Nachricht *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                <Send size={20} />
                {' '}
                {isSubmitting ? 'Envoi... / Sending...' : 'Envoyer / Send / Senden'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
